import { inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';
import {
  BillingAddress,
  CreateBillingAddressParams
} from '~core/models/billing-address.model';
import { FreeRequestParams } from '~core/models/shared.models';

@Injectable()
export class BillingAddressService {
  private _apiConstantsService = inject(ApiConstantsService);
  private _httpClient = inject(HttpClient);

  get apiUrl(): string {
    return this._apiConstantsService.billingAddressUrl;
  }

  read(billingAddressId: string): Observable<BillingAddress> {
    return this._httpClient.get<BillingAddress>(
      `${this.apiUrl}/${billingAddressId}`
    );
  }

  list(
    params?: FreeRequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<BillingAddress>> {
    return this._httpClient.get<Pagination<BillingAddress>>(this.apiUrl, {
      params: {
        ...params,
        sort: params?.sort || 'createdAt',
        desc: params?.desc || 'createdAt'
      } as Record<string, any>
    });
  }

  create(data: CreateBillingAddressParams): Observable<BillingAddress> {
    return this._httpClient.post<BillingAddress>(this.apiUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    data: Partial<CreateBillingAddressParams>
  ): Observable<BillingAddress> {
    return this._httpClient.patch<BillingAddress>(`${this.apiUrl}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }
  delete(billingAddressId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${this.apiUrl}/${billingAddressId}`
    );
  }
}
